export class CubicleSld {
  pictureFileName: string;
  nameKey: string;
  constructor(pictureFileName: string, nameKey: string) {
    this.pictureFileName = pictureFileName;
    this.nameKey = nameKey;
  }
}
